/* eslint-disable @nx/enforce-module-boundaries */
import { Route } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { canActivateFn, canMatchFn } from '@kanzi-apes/kanzi-auth';
import { LayoutMainViewComponent } from './components/layout-main-view/layout-main-view.component';
import { importProvidersFrom } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import * as LocationState from '@kanzi-apes/kanzi-location';

const kanziTitle = 'Kanzi Maintenances';

export const appRoutes: Route[] = [
  {
    path: '',
    component: LayoutComponent,
    providers: [
      importProvidersFrom(
        StoreModule.forFeature(
          LocationState.LOCATIONS_FEATURE_KEY,
          LocationState.locationsReducer
        )
      ),
    ],
    title: kanziTitle,
    data: {
      breadcrumb: 'menu_breadcrumb.home',
    },
    canActivate: [canActivateFn],
    children: [
      {
        path: '',
        component: LayoutMainViewComponent,
      },
      {
        path: 'third-party',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-contacts').then(
            (m) => m.KanziContactsModule
          ),
        title: kanziTitle + ' - Third Party',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.thirds',
        },
      },
      {
        path: 'products',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-products').then(
            (m) => m.kanziProductsRfidRoutes
          ),
        title: kanziTitle + ' - Products',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.products',
        },
        providers: [],
      },
      {
        path: 'inventories',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-stock-summary').then(
            (m) => m.KanziStockSummaryModule
          ),
        title: kanziTitle + ' - Inventories',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.inventories',
        },
      },
      {
        path: 'moves',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-moves').then((m) => m.KanziMovesModule),
        title: kanziTitle + ' - Moves',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.moves',
        },
      },
      {
        path: 'production-orders',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-production-order').then(
            (m) => m.KanziProductionOrderModule
          ),
        title: kanziTitle + ' - Production Orders',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.production_orders',
        },
      },
      {
        path: 'purchase-orders',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-purchase-order').then(
            (m) => m.KanziPurchaseOrderModule
          ),
        title: kanziTitle + ' - Purchase Orders',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.purchase_orders',
        },
      },
      {
        path: 'print-orders',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-print-order').then(
            (m) => m.KanziPrintOrderModule
          ),
        title: kanziTitle + ' - Print Orders',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.print_orders',
        },
      },
      {
        path: 'operations',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-operations').then(
            (m) => m.KanziOperationsModule
          ),
        title: kanziTitle + ' - Operations',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.operations',
        },
      },
      {
        path: 'packings',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-logistic-packing').then(
            (m) => m.KanziLogisticPackingModule
          ),
        title: kanziTitle + ' - Packings',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.packings',
        },
      },
      {
        path: 'maintenance',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-maintenance').then(
            (m) => m.KanziMaintenanceModule
          ),
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.maintenances',
        },
      },
      {
        path: 'maintenance-configs',
        loadChildren: () => import('@kanzi-apes/kanzi-maintenance-configs').then(
          (m) => m.KanziMaintenanceConfigsModule
        ),
        canMatch: 
          [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.maintenances_configs',
        },
      },
      {
        path: 'budgets',
        loadChildren: () =>
          import('kanzi-budgets').then((m) => m.kanziBudgetsRoutes),
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.budgets',
        },
      },
      {
        path: 'audits',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-audits').then((m) => m.KanziAuditsModule),
        title: kanziTitle + ' - Audits',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.inventories_counts',
        },
      },
      {
        path: 'invoicing',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-invoicing').then(
            (m) => m.kanziInvoicingRoutes
          ),
        title: kanziTitle + ' - Invoicing',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.invoicing',
        },
      },
      {
        path: 'inventories-counts',
        loadChildren: () =>
          import('kanzi-stock-summary-count').then(
            (m) => m.kanziStockSummaryCountRoutes
          ),
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.inventories_counts',
        },
      },
      {
        path: 'analytics',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-analytics-reports').then(
            (m) => m.KanziAnalyticsReportsModule
          ),
        title: kanziTitle + ' - Analytics',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.analytics',
        },
      },
      {
        path: 'locations',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-location').then(
            (m) => m.KanziLocationModule
          ),
        title: kanziTitle + ' - Locations',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.locations',
        },
      },
      {
        path: 'authorizations',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-asset-authorizations').then(
            (m) => m.kanziAssetAuthorizationsRoutes
          ),
        title: kanziTitle + ' - Authorizations',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.authorizations',
        },
      },
      {
        path: 'screen-control',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-screen-control').then(
            (m) => m.kanziScreenControlRoutes
          ),
        title: kanziTitle + ' - Screen Control',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.screen_control',
        },
        providers: [],
      },
    ],
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('@kanzi-apes/kanzi-auth').then((m) => m.kanziAuthRfidRoutes),
    title: kanziTitle + ' - Login',
    providers: [],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
